module.exports = __webpack_public_path__ + "static/img/iconfont.a5102908.svg";